import configs from '../../../conf';
const config = configs[process.env.NODE_ENV];

function crisp() {
  const user = JSON.parse(localStorage.getItem('userDetails'));
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = config.crispId;

  (function() {
    var d = document;
    var s = d.createElement('script');

    s.src = 'https://client.crisp.chat/l.js';
    s.async = 1;
    d.getElementsByTagName('head')[0].appendChild(s);
  })();
}

export default crisp;
